import { getClientCapabilities } from '@/features/projects/clientCapabilities';
import type { QueryClient } from '@tanstack/react-query';

import { fetchCurrentDesktopTarget } from './resolveDesktopTargetTurn';

/**
 * Desktop attachment for an on-demand routine run.
 *
 * Prefer a live roster target (native heartbeat). If none is registered yet,
 * fall back to triggering-client capabilities so local computer-use still
 * executes on this desktop. Lives next to the roster client because that
 * probe and the Tauri caps read are app couplings a headless package must
 * not import.
 */
// eslint-disable-next-line @heidi/rules/no-new-carved-domain-data -- app-side resolveRunRequestExtras binding: roster + Tauri caps cannot live in @heidi/agents/data; kept out of workflows/hooks.ts so the Green routines excludedSymbols ratchet does not grow
export const resolveWorkflowRunRequestExtras = async (
  queryClient: QueryClient
): Promise<{ target_id?: string; client_capabilities?: unknown }> => {
  const target = await fetchCurrentDesktopTarget(queryClient).catch(() => undefined);
  if (target?.target_id) return { target_id: target.target_id };
  const capabilities = await getClientCapabilities().catch(() => null);
  return capabilities ? { client_capabilities: capabilities } : {};
};
